import styled from 'styled-components';
import dayjs from 'dayjs';
import { P, fs, radius } from '../theme/tokens';

const FAILED = new Set(['failed', 'undelivered']);

const Row = styled.li`
  display: flex;
  flex-direction: column;
  align-items: ${(p) => (p.$out ? 'flex-end' : 'flex-start')};
`;

const Bubble = styled.div`
  max-width: 74%;
  padding: 10px 14px;
  border-radius: ${radius.lg}px;
  border-bottom-${(p) => (p.$out ? 'right' : 'left')}-radius: 4px;
  font-size: ${fs.sm}px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
  opacity: ${(p) => (p.$pending ? 0.6 : 1)};
  background: ${(p) => (p.$out ? P.grad : P.white)};
  color: ${(p) => (p.$out ? P.white : P.ink)};
  border: 1px solid ${(p) => (p.$failed ? P.danger : p.$out ? 'transparent' : P.line)};
`;

const Meta = styled.div`
  margin-top: 4px;
  padding: 0 4px;
  font-size: 11px;
  color: ${(p) => (p.$failed ? P.danger : P.subtle)};
`;

export default function MessageBubble({ message }) {
  const out = message.direction === 'outbound';
  const failed = FAILED.has(message.status);
  const state = message._optimistic
    ? ' · Sending…'
    : failed
      ? ` · Not delivered${message.errorCode ? ` (error ${message.errorCode})` : ''}`
      : '';

  return (
    <Row $out={out}>
      <Bubble $out={out} $pending={message._optimistic} $failed={failed}>
        {message.body}
      </Bubble>
      <Meta $failed={failed}>
        {dayjs(message.createdAt).format('MMM D, h:mm A')}
        {state}
      </Meta>
    </Row>
  );
}
